import { useContext } from "react";
import { useParams } from "react-router-dom";
import { SectionTitle } from "../../../sitel/demon/ui/atoms";
import AppContext from "../../../services/appContext";
import { exemptionPageTitle, exemptionTypes } from "../../../services/exemptions";
import RelCovidVaxBoosterForm from "./relCovidVaxNBoosterForm";
import RelFluVaxForm from "./relFluVaxForm";
import RelN95FitForm from "./relN95FitForm";
import { DemonTile } from '../../../sitel/demon/ui/molecules'

//TODO rename to index.jsx once Amanuel is done, it is called temp so it does not conlicts
export default function Step2ExemptionForm() {
    const { exemptionType, requestId } = useParams();

    //See if we have some prefilled values user already entered at a previously
    const appData = useContext(AppContext);
    const currentRequest = appData.userCurrentOhrequests.filter(userOhrequest => userOhrequest.ohrequest_id === requestId);
    const fields = currentRequest[0] ? currentRequest[0].fields.replace('\\','') : "";
    let fieldsJSON = {};
    try{
        fieldsJSON = fields.length>2 ? JSON.parse(fields):{};
        
    } catch(err){
        console.log('NOT LEGIT JSON use the empty default',err);
    }

    const moreInfoFields = currentRequest[0] ? currentRequest[0].extra_data.replace('\\','') : "";
    let moreInfoFieldsJSON = {};
    try{
        moreInfoFieldsJSON = moreInfoFields.length>2 ? JSON.parse(moreInfoFields):{};
        moreInfoFieldsJSON = moreInfoFieldsJSON.moreInfo || {};
    } catch(err){
        console.log('NOT LEGIT moreInfoFields json use the empty default',err);
    }

    //Render
    return (
        <>
            <SectionTitle>{exemptionPageTitle[exemptionType]}</SectionTitle>
            <DemonTile title="Religious Exemption Documentation">
                {TheForm(exemptionType, requestId, fieldsJSON,moreInfoFieldsJSON)}
            </DemonTile>
        </>
    );
}


function TheForm(exemptionType, requestId, fieldsJSON,moreInfoFieldsJSON) {
    switch (exemptionType) {
        case exemptionTypes.relCovidBooster:
        case exemptionTypes.relCovidVax:
            return <RelCovidVaxBoosterForm exemptionType={exemptionType} requestId={requestId} fieldsJSON={fieldsJSON} moreInfoFieldsJSON={moreInfoFieldsJSON} />

        case exemptionTypes.relFluVax:
            return <RelFluVaxForm exemptionType={exemptionType} requestId={requestId} fieldsJSON={fieldsJSON} moreInfoFieldsJSON={moreInfoFieldsJSON} />

        case exemptionTypes.relN95Fit:
            return <RelN95FitForm exemptionType={exemptionType} requestId={requestId} fieldsJSON={fieldsJSON} moreInfoFieldsJSON={moreInfoFieldsJSON} />

        default:
            return null;
    }
}
